//** lead-source Api with Tab Management

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import showLoader from '@components/loader';
import { setLoading } from '../../../../@core/components/skelton/store';

// ** Get Email Configuration
export const getEmailConfiguration = createAsyncThunk('emailSlice/getEmailConfiguration', async (tabId, { dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        const params = tabId === '3' ? { isEmailSharing: true } : {};
        const response = await axios.get('/get-active-email-configuration', {
            params,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return response?.data?.data; // Return the data directly
    } catch (err) {
        console.log('err', err);
        dispatch(setLoading(false)); // Ensure loading is set to false in case of error
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err?.response?.data || 'Error');
    }
});

// ** Add Email Configuration
export const emailConfig = createAsyncThunk('emailSlice/emailConfig', async (data, { dispatch }) => {
    showLoader(true);
    try {
        let response = await axios.post('/email-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Config Added successfully.');
        dispatch(getEmailConfiguration());
        showLoader(false);
        return Promise.resolve(response);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

// ** Delete Email Configuration
export const deleteEmailConfig = createAsyncThunk('emailSlice/deleteEmailConfig', async (id) => {
    try {
        let response = await axios.delete('/email-configuration/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

// ** Update Email Status
export const updateEmailStatus = createAsyncThunk('emailSlice/updateEmailStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Changed successfully.');
        await dispatch(getEmailConfiguration());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateEmailSharingSettings = createAsyncThunk('emailSlice/updateEmailSharingSettings', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/email-sharing/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Changed successfully.');
        await dispatch(getEmailConfiguration());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEmailPermissions = createAsyncThunk('emailSlice/getEmailPermissions', async (id, { dispatch }) => {
    try {
        let response = await axios.get('/email-sharing/custom/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // await dispatch(getEmailConfiguration());
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const addEmailPermissions = createAsyncThunk('emailSlice/addEmailPermissions', async (data) => {
    try {
        let response = await axios.post('/email-config-custom', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Config Added successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// ** Email Slice with Tab Management
export const emailSlice = createSlice({
    name: 'emailSlice',
    initialState: {
        data: [],
        emailPermissions: [],
        activeTab: 'email'
    },
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        removeEmailPermissions: (state) => {
            state.emailPermissions = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getEmailConfiguration.fulfilled, (state, action) => {
            state.data = action.payload;
        });
        builder.addCase(getEmailPermissions.fulfilled, (state, action) => {
            state.emailPermissions = action.payload;
        });
    }
});

export const { setActiveTab, removeEmailPermissions } = emailSlice.actions;
export default emailSlice.reducer;
